import { render } from "./BaseToast.vue?vue&type=template&id=6c2d6700"
import script from "./BaseToast.vue?vue&type=script&lang=js"
export * from "./BaseToast.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__